import {
    USER_LOGOUT, FETCH_ADMIN_ORDERS   }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0 };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_ORDERS:
            console.log('in FETCH_ADMIN_ORDERS',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }


        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

